import { render, staticRenderFns } from "./personReqs.vue?vue&type=template&id=4790a2cc&scoped=true&"
import script from "./personReqs.vue?vue&type=script&lang=js&"
export * from "./personReqs.vue?vue&type=script&lang=js&"
import style0 from "./personReqs.vue?vue&type=style&index=0&id=4790a2cc&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4790a2cc",
  null
  
)

export default component.exports